var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z","stroke":"#5a6969","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.99 7C9.99 7 9.99224 7 9.995 7C9.99776 7 10 7 10 7C10 7 9.99776 7 9.995 7C9.99224 7 9.99 7 9.99 7Z","stroke":"#5a6969","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10 9V13","stroke":"#5a6969","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

InfoIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
